export default __webpack_public_path__ + "static/media/italic.138596e1.svg";